import { Helmet } from "react-helmet-async";

const SITE = process.env.REACT_APP_BACKEND_URL;

export default function Seo({ title, description, path = "/" }) {
  const fullTitle = title.includes("Bytevora") ? title : `${title} | Bytevora`;
  const url = SITE ? `${SITE}${path}` : undefined;
  const image = SITE ? `${SITE}/og-image.png` : undefined;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {url && <link rel="canonical" href={url} />}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      {url && <meta property="og:url" content={url} />}
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {image && <meta name="twitter:image" content={image} />}
    </Helmet>
  );
}
